import Panel from '../../apricot/Panel';
import Link from '../Link';
import { formatDate, isDatePast } from '../../../date';
import { numberFormat } from '../../../numeral';
import styles from '../../../../sass/status.module.scss';

var PanelBody = function PanelBody(_ref) {
  var _ref$numberTakingExam = _ref.numberTakingExam,
      numberTakingExam = _ref$numberTakingExam === void 0 ? 0 : _ref$numberTakingExam,
      _ref$numberNotTakingE = _ref.numberNotTakingExam,
      numberNotTakingExam = _ref$numberNotTakingE === void 0 ? 0 : _ref$numberNotTakingE,
      _ref$numberUndecided = _ref.numberUndecided,
      numberUndecided = _ref$numberUndecided === void 0 ? 0 : _ref$numberUndecided,
      _ref$numberUnused = _ref.numberUnused,
      numberUnused = _ref$numberUnused === void 0 ? 0 : _ref$numberUnused,
      standardExamDecisionDeadline = _ref.standardExamDecisionDeadline,
      secondSemesterExamDecisionDeadline = _ref.secondSemesterExamDecisionDeadline,
      numberClassesExamDecisionsNotConfirmed = _ref.numberClassesExamDecisionsNotConfirmed,
      history = _ref.history;
  var teacherConfirmId = 'teacherNotConfirmed';

  var ExamDecision = function ExamDecision(_ref2) {
    var title = _ref2.title,
        number = _ref2.number,
        type = _ref2.type;
    return /*#__PURE__*/React.createElement("div", {
      className: styles['status-panel-border']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['status-title']
    }, title), /*#__PURE__*/React.createElement("div", {
      className: styles['status-number']
    }, /*#__PURE__*/React.createElement(Link, {
      history: history,
      path: "/students?oe=".concat(type)
    }, /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "View all students with ", type.toLowerCase(), " for exam intent"), numberFormat(number))));
  };

  var EditLink = function EditLink(_ref3) {
    var describedby = _ref3.describedby;
    return /*#__PURE__*/React.createElement(Link, {
      history: history,
      path: "/settings?scroll=examDecisionsPanel",
      "aria-describedby": describedby
    }, "edit");
  };

  var StandardDecision = function StandardDecision(_ref4) {
    var standardExamDecisionDeadline = _ref4.standardExamDecisionDeadline,
        secondSemesterExamDecisionDeadline = _ref4.secondSemesterExamDecisionDeadline;
    var formattedStandardDecisionDate = formatDate(standardExamDecisionDeadline);
    var id = 'standardDecision';
    var editLink = /*#__PURE__*/React.createElement(EditLink, {
      describedby: id
    });
    if (isDatePast(standardExamDecisionDeadline)) return /*#__PURE__*/React.createElement("p", {
      id: id
    }, "Decision deadline, ", /*#__PURE__*/React.createElement("strong", null, formattedStandardDecisionDate), ", has passed ", editLink);
    return /*#__PURE__*/React.createElement("p", {
      id: id
    }, secondSemesterExamDecisionDeadline ? 'Standard decision deadline: ' : 'Decision deadline: ', /*#__PURE__*/React.createElement("strong", null, formattedStandardDecisionDate), " ", editLink);
  };

  var SecondSemesterDecision = function SecondSemesterDecision(_ref5) {
    var secondSemesterExamDecisionDeadline = _ref5.secondSemesterExamDecisionDeadline;
    var formattedSecondSemesterDate = formatDate(secondSemesterExamDecisionDeadline);
    var id = 'secondSemesterDecision';
    var editLink = /*#__PURE__*/React.createElement(EditLink, {
      describedby: id
    });
    if (isDatePast(secondSemesterExamDecisionDeadline)) return /*#__PURE__*/React.createElement("p", {
      id: id
    }, "Second semester deadline,", ' ', /*#__PURE__*/React.createElement("strong", null, formattedSecondSemesterDate), ", has passed ", editLink);
    return /*#__PURE__*/React.createElement("p", {
      id: id
    }, "Second semester decision deadline:", ' ', /*#__PURE__*/React.createElement("strong", null, formattedSecondSemesterDate), " ", editLink);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles['status-panel-container']
  }, /*#__PURE__*/React.createElement(ExamDecision, {
    title: "Taking",
    number: numberTakingExam,
    type: "YES"
  }), /*#__PURE__*/React.createElement(ExamDecision, {
    title: "Not Taking",
    number: numberNotTakingExam,
    type: "NO"
  }), /*#__PURE__*/React.createElement(ExamDecision, {
    title: "Undecided",
    number: numberUndecided,
    type: "UNDECIDED"
  }), numberUnused ? /*#__PURE__*/React.createElement(ExamDecision, {
    title: "Unused",
    number: numberUnused,
    type: "UNUSED"
  }) : null), standardExamDecisionDeadline ? /*#__PURE__*/React.createElement(StandardDecision, {
    standardExamDecisionDeadline: standardExamDecisionDeadline,
    secondSemesterExamDecisionDeadline: secondSemesterExamDecisionDeadline
  }) : null, secondSemesterExamDecisionDeadline ? /*#__PURE__*/React.createElement(SecondSemesterDecision, {
    secondSemesterExamDecisionDeadline: secondSemesterExamDecisionDeadline
  }) : null, numberClassesExamDecisionsNotConfirmed !== undefined && numberClassesExamDecisionsNotConfirmed !== null ? /*#__PURE__*/React.createElement("p", {
    id: teacherConfirmId
  }, "Not teacher confirmed:", ' ', /*#__PURE__*/React.createElement(Link, {
    history: history,
    path: "/courses?tcon=N",
    "aria-describedby": teacherConfirmId
  }, /*#__PURE__*/React.createElement("strong", null, numberFormat(numberClassesExamDecisionsNotConfirmed)))) : null);
};

export default (function (props) {
  return /*#__PURE__*/React.createElement(Panel, {
    title: "Exam Registrations",
    panelClass: styles['exam-reg-panel'],
    body: /*#__PURE__*/React.createElement(PanelBody, props)
  });
});